import { FC } from 'react';

import { BlacklistItem } from '@shared/api/giftCoupon/giftCoupon.interface';

import { formatPhone } from '../../utils/couponSearch.utils';

interface BlacklistSectionProps {
  blacklist: BlacklistItem[];
  onCopyToClipboard: (text: string) => void;
  onSearchByPhone: (phone: string) => void;
}

export const BlacklistSection: FC<BlacklistSectionProps> = ({
  blacklist,
  onCopyToClipboard,
  onSearchByPhone,
}) => {
  return (
    <div className="mx-4 mb-4 overflow-hidden rounded-lg bg-white shadow">
      <div className="border-b bg-red-50 px-4 py-3">
        <div className="flex items-center gap-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 text-red-600"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
              clipRule="evenodd"
            />
          </svg>
          <p className="text-sm font-medium text-red-800">
            중복 의심 번호 ({blacklist.length}건)
          </p>
        </div>
      </div>
      <div className="divide-y divide-gray-100">
        {blacklist.map((item) => (
          <div
            key={item.phoneNumber}
            className="flex items-center gap-4 px-4 py-3 hover:bg-gray-50"
          >
            <button
              onClick={() => onCopyToClipboard(item.phoneNumber)}
              className="shrink-0 font-mono text-sm font-medium text-gray-900 hover:text-indigo-600"
              title="클릭하여 복사"
            >
              {formatPhone(item.phoneNumber)}
            </button>
            <span className="shrink-0 rounded-full bg-red-100 px-2 py-0.5 text-xs font-bold text-red-700">
              {item.count}건
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap gap-1">
                {item.names.map((name, idx) => (
                  <span
                    key={idx}
                    className="rounded bg-gray-100 px-1.5 py-0.5 text-xs text-gray-700"
                  >
                    {name}
                  </span>
                ))}
              </div>
              {item.names.length >= 2 && (
                <p className="mt-0.5 text-[10px] text-red-500">다른 이름으로 신청</p>
              )}
            </div>
            <button
              onClick={() => onSearchByPhone(item.phoneNumber)}
              className="shrink-0 rounded bg-indigo-100 px-2 py-1 text-xs font-medium text-indigo-700 hover:bg-indigo-200"
            >
              검색
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
